<script lang="ts">
    import type DataProvider from '../services/data.provider'
    import type ServiceProvider from '../services/service.provider'
    import Search from './Search.svelte'

    export let dataProvider: DataProvider
    export let serviceProvider: ServiceProvider
</script>

<Search {dataProvider} {serviceProvider}/>
